import React from 'react';

const VisitedCategoryPage = () => <></>;

export default VisitedCategoryPage;
